function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { databaseListApi } from '@/api/develop';
export default {
  name: 'dataEntity-editor',
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  data: function data() {
    return {
      // myOption: JSON.parse(JSON.stringify({ ...this.optionModel })),
      unSystemEntityList: []
    };
  },
  computed: {
    // ...mapState({
    //   unSystemEntityList: (state) => state.common.unSystemEntityList
    // })
  },
  watch: {
    optionModel: {
      handler: function handler() {
        this.initchartStyle();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.initchartStyle();
    this.getdatabaseList();
  },
  methods: {
    getdatabaseList: function getdatabaseList() {
      var _this = this;
      databaseListApi().then(function (res) {
        _this.unSystemEntityList = res.data.list;
        var allEntityName = {};
        res.data.list.forEach(function (el) {
          allEntityName[el.id] = el.table_name_en;
        });
        localStorage.setItem('allEntityName', JSON.stringify(allEntityName));
      });
    },
    initchartStyle: function initchartStyle() {
      this.myOption = _objectSpread({}, this.optionModel);
    },
    changeEntity: function changeEntity(e) {
      var _this2 = this;
      // this.myOption.setDimensional = {
      //   dimension: [],
      //   metrics: [],
      //   targetValue: 1,
      //   showFields: [],
      //   dimensionRow: [],
      //   dimensionCol: []
      // }
      // this.myOption.setChartFilter = {
      //   equation: '',
      //   list: []
      // }
      this.myOption.dataEntity = e;
      // this.$emit('optionModelChange', this.myOption)
      this.$nextTick(function (e) {
        // this.$emit('update:optionModel', this.myOption)
        _this2.$emit('clearSearch', _this2.myOption);
      });
    }
  }
};